/**
 * 회원 탈퇴 1단계 (/m/member/leave) — 안내 동의·사유 선택 뒤 다음 단계
 * ($j.Pages.Mobile.MemberLeave / body data-page-name="MemberLeave")
 */
export default class MemberLeave {
    initialize() {
        $(function () {
            const $agree = $('#lv-agree');
            const $reason = $('#lv-reason');
            const $etc = $('#lv-etc');
            const $next = $('#lv-next');
            const $hint = $('#lv-hint');

            function reason() {
                const r = $reason.val() || '';
                return r === '기타' ? $.trim($etc.val()) : r;
            }

            function refresh() {
                const agreed = $agree.hasClass('is-on');
                const r = reason();
                let hint = '';
                if (!agreed && !r) hint = '유의사항 확인과 탈퇴 이유가 필요해요';
                else if (!agreed) hint = '유의사항을 확인해 주세요';
                else if (!$reason.val()) hint = '탈퇴 이유를 골라 주세요';
                else if (!r) hint = '기타 이유를 적어 주세요';
                $hint.text(hint);
                $next.prop('disabled', !!hint);
            }

            $agree.on('click keydown', function (e) {
                if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
                e.preventDefault();
                const on = !$agree.hasClass('is-on');
                $agree.toggleClass('is-on', on).attr('aria-checked', on ? 'true' : 'false');
                refresh();
            });

            $reason.on('change', function () {
                const etc = $reason.val() === '기타';
                $etc.prop('hidden', !etc);
                if (etc) $etc.trigger('focus');
                refresh();
            });
            $etc.on('input', refresh);

            $next.on('click', function () {
                if ($next.prop('disabled')) return;
                $next.prop('disabled', true).addClass('is-loading');
                $.post('/m/ajax/member/leave/reason', { reason: reason() }, null, 'json')
                    .done(function (res) {
                        if (res && res.result) { location.replace('/m/member/leave2'); return; }
                        $next.prop('disabled', false).removeClass('is-loading');
                        $j.Common.Util.swalert('탈퇴 이유를 저장하지 못했어요.\n잠시 후 다시 시도해 주세요.');
                    })
                    .fail(function () {
                        $next.prop('disabled', false).removeClass('is-loading');
                        $j.Common.Util.swalert('처리하지 못했어요.\n잠시 후 다시 시도해 주세요.');
                    });
            });
        });

    }
}
